import React, {useEffect, useState } from "react";
import { getAllCustomers, addCustomer, getAllSectors } from "../../utils/helper";
import Loader from "../../utils/Loader";
// import { useHistory } from "react-router-dom";
import { alertSuccess, alertError } from '../../utils/alerts';
import { states } from "../../utils/dataFile";
import { Link } from "react-router-dom/cjs/react-router-dom";

const INIT_STATE = {
    name: null,
    email: null,
    phone: null,
    address: null,
    website:null,
    state:"",
    city:"",
    country: "",
    sector: "",
};

export default function Customers() {
    const [loading, setLoading] = useState(false);
    const [customers, setCustomers] = useState(null);
    const [sectors, setSectors] = useState(null);
    // const history = useHistory();
    const [state, setState] = useState(INIT_STATE);

    useEffect(() => {
        setLoading(true);
        getAllCustomers()
            .then((res) => { 
                setCustomers(res.data.data);  
                setTimeout(() => {
                    setLoading(false)
                }, 3500);
            })
            .catch((err) => {
                console.log(err?.response)
                setTimeout(() => {
                    setLoading(false)
                }, 3500);
            });
    }, []);

    useEffect(() => {
        getAllSectors()
            .then((res) => {
                if(res.data.success){
                    setSectors(res.data.data);  
                } 
            })
            .catch((err) => {
                console.log(err?.response)
            });
    }, []);

    const handleChange = (e) => {
        e.persist();
        setState((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = { ...state };
        if(data.name && data.email && data.phone && data.address && data.website && data.state && data.country && data.city && data.sector){
            setLoading(true);
            addCustomer(data)
            .then((res) => {
                if(res.data.success){
                    alertSuccess(res.data.message);
                    window.location.reload();
                } else {
                    alertError(res.data.message)
                }
                setLoading(false);
                setTimeout(() => {
                    setLoading(false);
                }, 1500);
            })
            .catch((err) => {
                alertError(err?.response?.data?.error);
                setLoading(false);
            });
        }
    };


    return (
        <>
            <div className="spur-card-menu">
                <button data-toggle="modal" data-target="#modal" type="button" className="pull-right btn topbtn btn-primary">CREATE</button>
            </div>
            
            <h1 className="dash-title"><Link to="/sales" style={{color: '#454545'}}><i className="fa fa-arrow-left"></i> Go Back</Link></h1>

            <div className="row dash-row">
                
                <div className="col-md-12 col-sm-12 col-12">
                    <div className="card spur-card" style={{marginTop: 5}}>
                        <div className="card-header">
                            <div className="spur-card-title">Customers</div>
                        </div>
                        <div className="card-body">
                            <div className="my_profile">
                                {(!loading && customers && customers) ? 
                                    <div className="table-responsive">
                                        {(customers && customers.length > 0) ?
                                        <table className="table text-left text-caps table-bordered" id="myTable">
                                            <thead><tr><th>SN</th><th>Name</th><th>Email</th><th>Phone</th><th>Website</th><th>Address</th><th>State</th>
                                            <th>Country</th><th>View</th></tr></thead>
                                            <tbody>
                                                {customers && customers.map((row, index) => 
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{row?.name && row?.name}</td>
                                                        <td>{row?.email && row?.email}</td>
                                                        <td>{row?.phone && row?.phone}</td>
                                                        <td>{row?.website && row?.website}</td>
                                                        <td>{row?.address && row?.address}</td>
                                                        <td>{row?.state && row?.state}</td> 
                                                        <td>{row?.country && row?.country}</td> 
                                                        <td>
                                                            <button 
                                                                className='btn btn-preview'
                                                                disabled
                                                            >
                                                                    <i className="fa fa-eye"></i> View
                                                            </button>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table> : 
                                        <div className="alert alert-danger myerror d-block">No record found.</div> }
                                    </div>
                                : <Loader /> }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            
            <div id="modal" className="modal fade" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">ADD CUSTOMER</h4>
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12 form-group">
                                    <label className="control-label">Sector <span>*</span></label>
                                    <select className="form-control form-select" name="sector" id="sector" required 
                                    onChange={handleChange} defaultValue={state.sector && state.sector} disabled={loading}>
                                        <option value=''>Select...</option>
                                        {sectors && sectors.map((item, i) => (
                                            <option key={i} value={item._id}>{item.name}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Name <span>*</span></label>
                                    <input type="text" name="name" className="form-control" required placeholder="Name of Customer" 
                                     onChange={handleChange} defaultValue={state.name && state.name} disabled={loading} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Email <span>*</span></label>
                                    <input type="email" name="email" className="form-control" required placeholder="Email of Customer" 
                                     onChange={handleChange} defaultValue={state.email && state.email }  disabled={loading} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Phone <span>*</span></label>
                                    <input type="tel" name="phone" maxLength={11} className="form-control" required placeholder="Phone of Customer" 
                                     onChange={handleChange} defaultValue={state.phone && state.phone }  disabled={loading} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Website <span>*</span></label>
                                    <input type="text" name="website" className="form-control" required placeholder="Website of Customer" 
                                     onChange={handleChange} defaultValue={state.website && state.website }  disabled={loading} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Address <span>*</span></label>
                                    <input type="text" name="address" className="form-control" required placeholder="Address of Customer" 
                                     onChange={handleChange} defaultValue={state.address && state.address }  disabled={loading} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">City <span>*</span></label>
                                    <input type="text" name="city" className="form-control" required placeholder="City of Customer" 
                                     onChange={handleChange} defaultValue={state.city && state.city }  disabled={loading} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">State <span>*</span></label>
                                    <select className="form-control form-select" name="state" id="state" required 
                                    onChange={handleChange} defaultValue={state.state && state.state} disabled={loading}>
                                        <option value=''>Select...</option>
                                        {states && states.map((item, i) => (
                                            <option key={i} value={item.label}>{item.label}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Country <span>*</span></label>
                                    <select className="form-control form-select" name="country" id="country" required 
                                    onChange={handleChange} defaultValue={state.country && state.country} disabled={loading}>
                                        <option value=''>Select...</option>
                                        <option value="Nigeria">Nigeria</option>
                                        <option value="Ghana">Ghana</option>
                                    </select>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 form-group">
                                    <button 
                                        type="submit" 
                                        className="btn" 
                                        disabled={loading}
                                        onClick={handleSubmit} >Create</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        </>
    );
}
